export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11547.7f0f048c.jpg";